import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FileOptionsComponent } from './file-options.component';

const routes: Routes = [{ path: '', component: FileOptionsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FileOptionsRoutingModule { }
